import React from 'react';
import { PropTypes } from 'prop-types';

const ParagraphLineSM = ({
  text, align, classes, iconClass, size,
}) => (
  <p className={`${align} ${size} font-americaMonoRegular tracking-wide uppercase ${classes}`}>
    {text}
    {' '}
    {iconClass && <span className={`${iconClass}`} />}
  </p>
);

ParagraphLineSM.propTypes = {
  align: PropTypes.string,
  classes: PropTypes.string,
  text: PropTypes.string.isRequired,
  iconClass: PropTypes.string,
  size: PropTypes.string,
};

ParagraphLineSM.defaultProps = {
  align: '',
  classes: '',
  iconClass: '',
  size: 'text-xs',
};

export default ParagraphLineSM;
